























import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import StatusTag, {
  EStatus
} from '@/componentsV2/atoms/StatusTag/StatusTag.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';

@Component({
  components: {
    Typography,
    StatusTag,
    Checkbox
  }
})
export default class StatusProgram extends Vue {
  @Prop() tagText!: EStatus;
  @Prop() title!: string;
  @Prop() description!: string;
  @Prop() showToggle?: boolean;
  @Prop() enabled?: boolean;
}
